import React, { createContext, useContext } from "react";
import GlobalStore, { GlobalStoreClass } from "../../store/global-store";

// Create a context for the root store
const StoreContext = createContext<GlobalStoreClass | null>(null); // Add typing for RootStore

interface StoreProviderProps {
  children: React.ReactNode;
}

// Provider component
export const StoreProvider = ({ children }: StoreProviderProps) => {
  return (
    <StoreContext.Provider value={GlobalStore}>
      {children}
    </StoreContext.Provider>
  );
};

// Custom hook to access the stores
export const useStores = () => {
  const context = useContext(StoreContext);
  if (!context) {
    throw new Error("useStores must be used within a StoreProvider");
  }
  return context;
};
